import EmbedWidgetModal from './EmbedWidgetModal';

export default EmbedWidgetModal;
